import React, { useState } from 'react'
import { VIEWCONSTANT } from "../../../AppConstant/ViewConstant";

const Searchpatient = ({ onClose, onSelect }) => {

    const [searchPatentShow, setSearchPatentShow] = useState(false)

    return (
        <>
            <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText">
                                <h5 className="modal-title" id="exampleModalLabel">Search Patient</h5>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose} />
                        </div>
                        {searchPatentShow === false  ?
                        <div className='margin-user-reg'>
                            <div className='row'>
                                <div className="col-md-2">
                                    <div className="radio-group">
                                        <input
                                            type="radio"
                                            name="diseaseType"
                                            value="2"
                                        //   onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Sickle ID</span>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="radio-group">
                                        <input
                                            type="radio"
                                            name="diseaseType"
                                            value="2"
                                        //   onChange={handleDiseaseTypeChange}
                                        />
                                        <span>ABHA ID</span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="radio-group">
                                        <input
                                            type="radio"
                                            name="diseaseType"
                                            value="2"
                                        //   onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Mobile Number</span>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="radio-group">
                                        <input
                                            type="radio"
                                            name="diseaseType"
                                            value="2"
                                        //   onChange={handleDiseaseTypeChange}
                                        />
                                        <span>Registered in Useer's HF</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='row mt-5'>
                                    <div className='col-md-3'>
                                        <label>Enter Mobile Number <span className="Refre-red">*</span></label>
                                        <input type="text" placeholder='xxxxxx0123' className='exam-textarea' />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Select Disease</label>
                                        <div className="field">
                                            <select className="custom-select-slots">
                                                <option>Select Disease</option>
                                                <option value="ABHA Address">Sickle</option>
                                                <option value="ABHA Number">Thalassemia</option>
                                                <option value="Mobile Number">Other Variants</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="button-add-slot mt-5" onClick={()=>setSearchPatentShow(true)}>Search</button>
                        </div>

:

                        <div className='sicklePtentDetailsList'>
                           <div className='siclePatDetListRow'>
                                 <div className='siclePatDetListCol'>
                                      <h4>Sickle ID</h4>
                                      <p>330221</p>
                                 </div>
                                 <div className='siclePatDetListCol'>
                                      <h4>Patient Name</h4>
                                      <p>Praveen kalra</p>
                                 </div>
                                 <div className='siclePatDetListCol'>
                                      <h4>ABHA ID</h4>
                                      <p>78-1245-1235-7899</p>
                                 </div>
                           </div>
                           <div className='text-end actionSicklePateDetLis'>
                               <button class="button-add-slot mt-5" onClick={onSelect(VIEWCONSTANT.medicalHistory)}>Submit</button>
                           </div>
                        </div>
}

                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchpatient;
